import { render, staticRenderFns } from "./Totens.vue?vue&type=template&id=281359cc"
import script from "./Totens.vue?vue&type=script&lang=js"
export * from "./Totens.vue?vue&type=script&lang=js"
import style0 from "./Totens.vue?vue&type=style&index=0&id=281359cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports